import { FormGroup, RadioGroup } from "@blueprintjs/core";
import { EnumRadioProps, FieldLabeledProps } from "../../types/fieldTypes";
import { FieldLabel } from "../../CoreFields/FieldLabel/FieldLabel";
import { FormFieldErrorContainer } from "../../CoreFields/FieldError/FormFieldErrorContainer";
import { useEnumRadioField } from "./useEnumRadioField";
import { PrimaryButton } from "../../../Buttons";
import { faClose } from "@fortawesome/free-solid-svg-icons";

/** Base EnumRadioField Props*/
export interface EnumRadioFieldProps extends EnumRadioProps {
  labelProps?: FieldLabeledProps;
  showClearButton?: boolean;
}

const EnumRadioField: React.FC<EnumRadioFieldProps> = (props) => {
  const { localValue, setLocalValue } = useEnumRadioField(props);

  const handleClear = () => {
    setLocalValue(undefined);
    props.onSubmit && props.onSubmit(undefined);
  };

  return (
    <div className="ucl-base-input-radio-field-container">
      <FormGroup
        className={`${
          props.isRequired && !localValue && localValue !== 0
            ? "has-required-background"
            : "base-field"
        }`}
      >
        {props.label && (
          <FieldLabel
            labelName={props.label}
            tooltipDescription={props.description}
            fieldProps={{ ...props, value: localValue }}
            isRequired={props.isRequired}
            {...props.labelProps}
          />
        )}
        <div className="ucl-radio-group-container">
          <RadioGroup
            disabled={props.disabled}
            onChange={(e) => {
              setLocalValue(Number(e.currentTarget.value));
              props.onSubmit && props.onSubmit(Number(e.currentTarget.value));
            }}
            selectedValue={localValue}
            options={(props.optionValues || [])
              .filter((option) => option.value)
              .map((option, idx) => ({
                key: idx,
                label: option.label,
                value: Number(option.value),
              }))}
            inline
          />
          {props.showClearButton &&
            localValue !== null &&
            localValue !== undefined && (
              <div className="ucl-clear-button-container">
                <PrimaryButton
                  minimal
                  text="Clear"
                  iconProps={{
                    icon: faClose,
                  }}
                  onClick={handleClear}
                  disabled={props.disabled}
                  className="ucl-clear-button"
                />
              </div>
            )}
        </div>
        {props.errorMessages && (
          <FormFieldErrorContainer errorMessages={props.errorMessages} />
        )}
      </FormGroup>
    </div>
  );
};

export default EnumRadioField;
